export const productionGames = Object.freeze([
  Object.freeze({
    id: 'battlegunz',
    title: 'Battle Gunz',
    artwork: '/assets/games/battlegunz.png',
    preview: '/assets/live_simulator/battle_gunz.gif',
    route: '/games/battlegunz',
    description:
      'Enter a fast-paced neon arena, dodge enemy fire, unleash powerful weapons, and battle for a new high score with your Ordinal character.',
    genre: 'Arena Shooter',
    mode: 'Score Attack',
    supportedPlatforms: ['desktop'],
  }),
  Object.freeze({
    id: 'meteordinals',
    title: 'Meteordinals',
    artwork: '/assets/games/meteordinals.png',
    preview: '/assets/live_simulator/meteordinals.gif',
    route: '/games/meteordinals',
    description:
      'Guide your Ordinal through a relentless meteor storm, weave between incoming hazards, and survive as long as possible to climb the leaderboard.',
    genre: 'Survival Dodger',
    mode: 'Endless Run',
    supportedPlatforms: ['desktop', 'mobile'],
  }),
  Object.freeze({
    id: 'rocketordinals',
    title: 'Rocket Ordinals',
    artwork: '/assets/rocket_ordinals.png',
    preview: '/assets/live_simulator/rocket_ordinals.gif',
    route: '/games/rocketordinals',
    description:
      'Launch into a retro rocket-powered challenge, navigate dangerous obstacles, and push your Ordinal farther with every high-speed run.',
    genre: 'Arcade Runner',
    mode: 'Distance Challenge',
    supportedPlatforms: ['desktop', 'mobile'],
  }),
]);

export const formatWalletAddress = (address) => {
  if (!address) return '';
  if (address.length <= 12) return address;
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
};

export const leaderboardIdentity = (entry) => {
  if (entry && entry.userName) return entry.userName;
  const address = entry && (entry.ordinalAddress || entry.ethAddress);
  return address ? formatWalletAddress(address) : 'Anonymous';
};

export const ordinalImagePath = (entry) => {
  if (!entry || !entry.collectionName) return '';
  const collectionDirectory =
    entry.collectionName === 'doge' ? 'dogepunks' : entry.collectionName;

  if (entry.tokenId) {
    return `/assets/collections/${collectionDirectory}/${entry.collectionName}_${entry.collectionNumber}_${entry.tokenId}.png`;
  }

  if (
    entry.collectionNumber === undefined ||
    entry.inscriptionNumber === undefined ||
    !entry.inscriptionId
  ) {
    return '';
  }

  return `/assets/collections/${collectionDirectory}/${entry.collectionName}_${entry.collectionNumber}_${entry.inscriptionNumber}_${entry.inscriptionId}.png`;
};

export const collectionLeaderboardRows = (collections, metric) =>
  Object.entries(collections || {})
    .map(([name, values]) => ({ name, ...values }))
    .sort((first, second) => Number(second[metric] || 0) - Number(first[metric] || 0))
    .slice(0, 10);
